export abstract class IModalComponent {
    public isModalVisible: boolean = false;
    
    abstract handleModalHide(): void;
    public toggleModal(): void {
        this.isModalVisible = !this.isModalVisible;
    }
}